import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';
import { useMemo } from 'react';

import type { TripRead } from 'src/common/external/bambi-api/bambiApi';
import type { TripSubscriptionRead } from 'src/common/external/bambi-api/tripsApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelect } from 'src/common/primitives/MultiSelect/MultiSelect';
import { useTagOptions } from 'src/common/tags/useTagOptions';

interface TripTagsContextFieldsProps {
  fieldPath: string;
  label: string;
  selectedEntity?: TripRead | TripSubscriptionRead;
}

export default function TripTagsContextField({
  fieldPath,
  label,
  selectedEntity,
}: TripTagsContextFieldsProps) {
  const excludeTagIds = useMemo(
    () => selectedEntity?.tags?.map((tripTag) => tripTag.tag),
    [selectedEntity?.tags]
  );
  const { options, query, setQuery, resetQuery } = useTagOptions({
    excludeTagIds,
  });

  return (
    <FormFieldController name={fieldPath}>
      {({ field, fieldState }) => {
        return (
          <FormFieldContainer>
            <DefaultFormFieldLayout
              label={label}
              error={fieldState.error?.message?.toString()}
              inputId={fieldPath}
            >
              <MultiSelect
                options={options}
                searchable
                query={query}
                setQuery={setQuery}
                onClose={resetQuery}
                selected={field.value}
                onChange={(selected) => {
                  field.onChange(selected);
                }}
              />
            </DefaultFormFieldLayout>
          </FormFieldContainer>
        );
      }}
    </FormFieldController>
  );
}
